export default __webpack_public_path__ + "static/media/06.0e24a93a.png";